import { NgModule } from '@angular/core';
import { CapitalizePipe } from './capitalize.pipe';
import { KeysPipe } from './keys.pipe';
import { GroupByPipe } from './groupBy.pipe';
import { ReplacePipe } from './replace.pipe';
import { ShowBreakLinesPipe } from './show-break-lines';
import { RemoveZerosPipe } from './removeZeros.pipe';
import { VerFechaArg } from './verFechaArg';
import { ResaltarPalabraClavePipe } from './resaltar-palabra-clave.pipe';


@NgModule({
  declarations: [
    CapitalizePipe,
    KeysPipe,
    GroupByPipe,
    ReplacePipe,
    ShowBreakLinesPipe,
    RemoveZerosPipe,
    VerFechaArg,
    ResaltarPalabraClavePipe,
  ],
  imports: [

  ],
  exports: [
    CapitalizePipe,
    KeysPipe,
    GroupByPipe,
    ReplacePipe,
    ShowBreakLinesPipe,
    RemoveZerosPipe,
    VerFechaArg,
    ResaltarPalabraClavePipe,
  ]
})
export class PipesModule { }


// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts